<script lang="ts" setup>
import { useTranslation } from 'i18next-vue';
import { computed } from 'vue';

import type { FormSchema } from '@modules/forms/components/VForm/types';
import type { PlayerDetailsFormSchema, PlayerDetailsProps } from '@modules/players/submodules/PlayerProfile/types';
import type { Player } from '@modules/players/types';
import VBackButton from '@components/buttons/VBackButton/VBackButton.vue';
import { useFormatDate } from '@modules/core/composables/datetime';
import VForm from '@modules/forms/components/VForm/VForm.vue';
import { EFormInputTypes } from '@modules/forms/enums';
import { ADMIN_PLAYERS_LIST_ROUTE_NAME } from '@modules/players/constants';
import {
  TRANSLATION_GROUP_PLAYER_ACTIVITY,
} from '@modules/players/submodules/PlayerProfile/submodules/PlayerActivity/constants';
import {
  assert,
  isString,
} from '@utils/guards';

const props = defineProps<PlayerDetailsProps>();

// :TODO Discuss with the backend about integration locale_key to another or single response
const localeKey = 'columns_for_display_data.admin.observing_of_daily_statistics_players.index';
const { t } = useTranslation();
const { formatDate } = useFormatDate();

const formSchema = computed<FormSchema<PlayerDetailsFormSchema>>(() => {
  if (props.formProfileColumns && props.playerData) {
    const schema: FormSchema<PlayerDetailsFormSchema> = {};
    for (const column of props.formProfileColumns) {
      const value = props.playerData[column as keyof Player];
      assert(isString(value));
      schema[column] = {
        type: EFormInputTypes.TEXT,
        inputType: 'text',
        label: t(`${localeKey}.${column}`),
        value: formatDate(value),
      };
    }
    return schema;
  }
  return {};
});
</script>

<template>
  <VForm v-data-qa-auto-id="'PlayerActivityPage'"
    :schema="formSchema"
    readonly
  >
    <template #secondaryBtn>
      <VBackButton
        :label="$getTranslation(TRANSLATION_GROUP_PLAYER_ACTIVITY, 'PLAYER_DETAILS_BACK')"
        :to="{ name: ADMIN_PLAYERS_LIST_ROUTE_NAME }"
      />
    </template>
  </VForm>
</template>
